import { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';

interface InlineEditInputProps {
  value: string;
  placeholder?: string;
  onSave: (value: string) => void;
  onCancel: () => void;
  className?: string;
  autoFocus?: boolean;
}

export function InlineEditInput({
  value,
  placeholder = 'Inserisci nome...',
  onSave,
  onCancel,
  className,
  autoFocus = true,
}: InlineEditInputProps) {
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [autoFocus]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const trimmed = inputValue.trim();
    if (trimmed) {
      onSave(trimmed);
    } else {
      onCancel();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      onCancel();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      handleSubmit(e);
    }
  };

  const handleBlur = () => {
    const trimmed = inputValue.trim();
    if (trimmed) {
      onSave(trimmed);
    } else {
      onCancel();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex-1 min-w-0" onClick={(e) => e.stopPropagation()}>
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={placeholder}
        className={clsx(
          'w-full px-1 py-0.5 rounded text-[10px] bg-surface-primary border border-accent-violet focus:outline-none focus:ring-1 focus:ring-accent-violet',
          className
        )}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      />
    </form>
  );
}


